import { render, staticRenderFns } from "./Phone.vue?vue&type=template&id=9698318c&"
import script from "./Phone.vue?vue&type=script&lang=js&"
export * from "./Phone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9698318c')) {
      api.createRecord('9698318c', component.options)
    } else {
      api.reload('9698318c', component.options)
    }
    module.hot.accept("./Phone.vue?vue&type=template&id=9698318c&", function () {
      api.rerender('9698318c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/people/tabs/Phone.vue"
export default component.exports